<template><span class="amount-cell">{{ formatted }}</span></template>

<script>
import { formatMoney } from '../../services/moneyFormat'

export default {
  name: 'AmountCell',
  props: {
    value: { type: [Number, String], default: 0 },
    currency: { type: String, default: '' }
  },
  computed: {
    formatted() {
      return formatMoney(this.value, { currency: this.currency })
    }
  }
}
</script>

<style scoped>
.amount-cell {
  display: block;
  text-align: right;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
</style>
